export default __webpack_public_path__ + "static/media/bank.b3446575.svg";